import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DatePickerFieldWUT } from '../../../ui/date-picker-field';
export const DextDatePickerWUT = (props)=>{
    const fieldType = FIELD_TYPES.DEXT_DATE_PICKER;
    return /*#__PURE__*/ React.createElement(DatePickerFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=dext-date-picker-wut.js.map